import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useProfile } from '../Common/Hooks/UserHooks';
import { setAuthorization } from '../helpers/api_helper';
import { logoutUser } from '../slices/thunk';

const AuthProtected = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userProfile, loading, token } = useProfile();
    
    useEffect(() => {
      if (userProfile && !loading && token) {
        setAuthorization(token);
      } else if (!userProfile && loading && !token) {
        dispatch(logoutUser());
      }
    }, [token, userProfile, loading, dispatch]);

    if (!userProfile && loading && !token) {
      navigate(`/login`);
      // <Navigate to={{ pathname: "/login"}} />
    }
  
    return <>{props.children}</>;
}

export default AuthProtected
